/** Platform mark in rail, login, and browser tab. */
export const PLATFORM_LOGO = '/platform-logo.png';
